import PropTypes from "prop-types";
import React, { useMemo } from "react";
import GroupsSearch from "src/components/GroupsSearch";
import { useGroupTypes } from "src/contexts/global/WorkspaceContext";
import {
  ALL_DEMAND_GROUP_TYPES,
  ALL_DOES_NOT_PARTICIPATE_GROUP_TYPES,
  ALL_SUPPLY_GROUP_TYPES,
  DEFAULT_ALLOWED_GROUP_TYPE,
} from "src/pages/Workspaces/consts";
import {
  getActiveDemandGroupTypes,
  getActiveGroupTypes,
  getActiveSupplyGroupTypes,
} from "src/util/group";

import { useAIDashboardStore } from "../context/AIDashboardContext";

const CanvTeamSearch = ({
  channel,
  placeholder,
  label,
  "team-types-channel": groupTypesChannel,
}) => {
  const store = useAIDashboardStore(channel);
  const publish = store((state) => state.publish);

  const groupTypes = useGroupTypes();

  // Subscribe to group types channel if provided
  // Use a dummy channel if none provided to avoid conditional hook calls
  const channelToUse = groupTypesChannel || "__no-channel__";
  const groupTypesStore = useAIDashboardStore(channelToUse);
  const storeValue = groupTypesStore((state) => state.value);
  const selectedGroupTypeKeys = groupTypesChannel ? storeValue : null;

  const targetGroupTypes = useMemo(() => {
    // If group types are selected via channel, use those
    if (selectedGroupTypeKeys && selectedGroupTypeKeys.length > 0) {
      const targetTypes = {};

      selectedGroupTypeKeys.forEach((key) => {
        if (key === DEFAULT_ALLOWED_GROUP_TYPE.key) {
          // ALL - include all active group types
          const activeTypes = getActiveGroupTypes(groupTypes);
          activeTypes.forEach((type) => {
            targetTypes[type.id] = type;
          });
        } else if (key === ALL_DEMAND_GROUP_TYPES.key) {
          // ALL_DEMAND - include all demand types
          const demandTypes = getActiveDemandGroupTypes(groupTypes);
          demandTypes.forEach((type) => {
            targetTypes[type.id] = type;
          });
        } else if (key === ALL_SUPPLY_GROUP_TYPES.key) {
          // ALL_SUPPLY - include all supply types
          const supplyTypes = getActiveSupplyGroupTypes(groupTypes);
          supplyTypes.forEach((type) => {
            targetTypes[type.id] = type;
          });
        } else if (key === ALL_DOES_NOT_PARTICIPATE_GROUP_TYPES.key) {
          // ALL_DOES_NOT_PARTICIPATE - include all does not participate types
          const activeTypes = getActiveGroupTypes(groupTypes);
          activeTypes.forEach((type) => {
            if (!type.isDemand && !type.isSupply) {
              targetTypes[type.id] = type;
            }
          });
        } else if (groupTypes[key]) {
          // Individual group type
          targetTypes[key] = groupTypes[key];
        }
      });

      return targetTypes;
    }

    // Default behavior - return all group types as object
    const activeTypes = getActiveGroupTypes(groupTypes);
    const defaultTypesObject = {};
    activeTypes.forEach((type) => {
      defaultTypesObject[type.id] = type;
    });
    return defaultTypesObject;
  }, [groupTypes, selectedGroupTypeKeys]);

  const handleGroupSelected = (group) => {
    if (group?.id) {
      publish(group);
    }
  };

  return (
    <div>
      {label && <div style={{ marginBottom: "8px" }}>{label}</div>}
      <GroupsSearch
        key={JSON.stringify(Object.keys(targetGroupTypes).sort())}
        placeholder={placeholder || "Search teams"}
        groupTypes={groupTypes}
        targetGroupTypes={targetGroupTypes}
        onGroupSelected={handleGroupSelected}
      />
    </div>
  );
};

CanvTeamSearch.propTypes = {
  channel: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  "team-types-channel": PropTypes.string,
};

export default CanvTeamSearch;
